import { useNavigate } from "react-router-dom";
import { AppLayout } from "../../../layout/AppLayout";
import { Arrow } from "../../../components/svg/Wallet/Wallet";
import { Card } from "../../../components/Card";
import { BaseInput } from "../../../components/input/baseInput";
import Button from "../../../components/button/Button";

export const CofirmCardDetails = () => {
  const navigate = useNavigate();
  return (
    <AppLayout noNav bg={"!bg-[#F8F8F8]"}>
      <div className=" min-h-screen px-4 pt-16">
        <div className="relative flex items-center justify-center">
          <Arrow
            onClick={() => navigate(-1)}
            stroke="#fff"
            className="text-lg absolute left-0 cursor-pointer "
          />
          <p className="font-bold text-xl text-primary-black">Card Top Up</p>
        </div>
        <Card className="my-12 flex flex-col gap-9">
          <BaseInput
            label="Card Number"
            type="number"
            inputClass="bg-[#F8F8F8]"
            placeholder="Enter your card 16 digit number"
          />

          <div className="flex gap-5 items-center">
            <BaseInput
              label="Expiry Date"
              type="number"
              inputClass="bg-[#F8F8F8]"
              placeholder="MM      /     YY"
              className="flex-1"
            />
            <BaseInput
              label="CVV"
              type="number"
              inputClass="bg-[#F8F8F8]"
              placeholder="Enter Card CVV"
              className="flex-1"
            />
          </div>
          <BaseInput
            label="Pin"
            type="number"
            placeholder="Enter your card PIN"
            inputClass="bg-[#F8F8F8]"
          />
        </Card>
        <Button
          onClick={() => {}}
          text="Fund Account"
          className="!py-4 !rounded-[50px]"
        />
      </div>
    </AppLayout>
  );
};
